import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
    Container,
    Typography,
    Grid,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Paper,
    Card,
    CardContent,

    Box,
    Tabs,
    Tab,
} from '@mui/material';
import Footer from '../navbar/Footer';

const annuaires = [
    {
        title: "Résultats définitifs du Troisième Recensement Général de la Population et de l'Habitat de 2008",
        link: "/documents/recensements/RGPH-RESULTATS-DEFINITIFS.pdf",
        description: "La présentation des résultats définitifs du Troisième Recensement Général de la Population et de l'Habitat réalisé en 2008.",
        datePublished: "2010",
    },
    {
        title: "Répartition de la population issue du RGPH 2008",
        link: "/documents/recensements/Répartition-de-la-population-issue-du-RGPH-2008.pdf",
        description: "La répartition de la population issue du Troisième Recensement Général de la Population et de l'Habitat de 2008.",
        datePublished: "2010",
    },
];

const odd = [
    { title: "Chapitre 1", link: "/documents/recensements/Chapitre-1.xlsx" },
    { title: "Chapitre 2", link: "/documents/recensements/Chapitre-2.xlsx" },
    { title: "Chapitre 3", link: "/documents/recensements/Chapitre-3.xlsx" },
    { title: "Chapitre 4", link: "/documents/recensements/Chapitre-4.xls" },
    { title: "Chapitre 5", link: "/documents/recensements/Chapitre-5.xlsx" },
    { title: "Chapitre 6", link: "/documents/recensements/chapitre-6.xlsx" },
    { title: "Chapitre 7", link: "/documents/recensements/Chapitre-7.xls" },
    { title: "Chapitre 8", link: "/documents/recensements/Chapitre-8.xlsx" },
];

function Recensement() {
    const [activeTab, setActiveTab] = useState(0); 

    const handleChangeTab = (event, newValue) => {
        setActiveTab(newValue); 
    };

    return (
        <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '20px' }}>
            <NavigationBar />
            <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
                <Tabs
                    value={activeTab}
                    onChange={handleChangeTab}
                    textColor="inherit"
                    indicatorColor="secondary"
                    centered
                >
                    <Tab label="Rapport" />
                    <Tab label="Tableaux" />
                </Tabs>

            
                {activeTab === 0 && (
                    <>
                        <Typography variant="h4" align="justify" gutterBottom style={{ color: 'green', marginTop: '20px' }}>
                            Rapport du Troisième Recensement Général de la Population et de l'Habitat (RGPH) de 2008
                        </Typography>
                        <Divider style={{ margin: '20px 0' }} />
                        <Typography variant="body1" align="left" paragraph>
                            Le Troisième Recensement Général de la Population et de l'Habitat(RGPH), réalisé en 2008, constitue une étape majeure dans l’analyse démographique du Burundi. Selon les résultats de ce recensement, la population du pays s'élevait à 8.053.574 habitants, répartis entre 3.964.906 hommes et 4.088.668 femmes. Ce recensement a pour objectif de fournir des données précises et actualisées qui servent de base pour le développement des politiques publiques, la planification socio-économique et la mise en œuvre d'interventions en faveur du bien-être de la population.
                        </Typography>
                    
                        <Grid container spacing={1}>
                            {annuaires.map((annuaire, index) => (
                                <Grid item xs={12} md={12} key={index}>
                                    <Card elevation={4} style={{ borderRadius: '8px' }}>
                                        <CardContent>
                                            <Grid container spacing={2} alignItems="center">
                                                <Grid item xs={4}>
                                                    <Box
                                                        component="img"
                                                        sx={{
                                                            width: '100%',
                                                            height: 'auto',
                                                            borderRadius: '4px',
                                                        }}
                                                        src="asset/cover/cover.jpg"
                                                        alt="Document Cover"
                                                    />
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <a
                                                        href={annuaire.link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ textDecoration: 'none' }}
                                                    >
                                                        <Typography variant="subtitle1" component="div" style={{ fontWeight: 'bold', color: 'green' }}>
                                                             {<DownloadIcon />}{annuaire.title}
                                                        </Typography>
                                                    </a>
                                                    <Typography variant="body2" color="textSecondary">
                                                        {annuaire.description}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </>
                )}

            
                {activeTab === 1 && (
                    <>
                        <Divider style={{ margin: '20px 0' }} />
                        <Typography variant="h4" align="justify" gutterBottom style={{ color: 'green', marginTop: '20px' }}>
                            Tableaux
                        </Typography>
                        <Typography variant="body1" align="left" paragraph>
                            Cette section présente des statistiques clés issues du recensement de 2008, des comparaisons par catégories d'âge, de sexe et de région, facilitant ainsi l'analyse et la compréhension des tendances démographiques au sein du pays.
                        </Typography>
                        <TableContainer component={Paper} elevation={3} style={{ borderRadius: '8px' }}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableBody>
                                    <TableRow>
                                        {odd.map((document, index) => (
                                            <TableCell key={index} style={{ borderBottom: 'none' }}>
                                                <a
                                                    href={document.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        textDecoration: 'none',
                                                        fontWeight: '500',
                                                        display: 'block',
                                                        padding: '8px',
                                                        borderRadius: '4px',
                                                        color: 'green',
                                                        transition: 'background-color 0.3s',
                                                    }}
                                                >
                                                    {<DownloadIcon />} {document.title}
                                                </a>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                )}
            </Container>

            <br />
            <br />
            <Footer />
        </div>
    );
}

export default Recensement;